import React from "react";
import {
  ESPNLogo,
  NFLLogo,
  RedZoneLogo,
  YahooLogo,
} from "../components/CustomIcons";
import sleeperLogo from "../../src/assets/images/sleeper-logo.png";
import squareIcon from "../../src/assets/images/icon-square.png";
import venmoIcon from "../../src/assets/images/icon-venmo.png";
import PayPalIcon from "../../src/assets/images/icon-PayPal.png";

export enum IconName {
  YAHOO = "Yahoo",
  ESPN = "ESPN",
  SLEEPER = "Sleeper",
  NFL = "NFL",
  REDZONE = "RedZone",
  CASHAPP = "Cash App",
  VENMO = "Venmo",
  PAYPAL = "PayPal",
}

export const Icons = {
  [IconName.YAHOO]: <YahooLogo />,
  [IconName.ESPN]: <ESPNLogo />,
  [IconName.SLEEPER]: <img src={sleeperLogo} alt="Sleeper" />,
  [IconName.NFL]: <NFLLogo />,
  [IconName.REDZONE]: <RedZoneLogo />,
  [IconName.CASHAPP]: <img src={squareIcon} alt="" />,
  [IconName.VENMO]: <img src={venmoIcon} alt="" />,
  [IconName.PAYPAL]: <img src={PayPalIcon} alt="" />,
} satisfies Record<IconName, React.ReactNode>;

export const flRatingOptions = [
  {
    value: "Pee Wee Level 1 | Basic",
    label: ["Pee Wee", "Level 1 | Basic"],
  },
  {
    value: "Two Hand Touch Level 2 | Challenging",
    label: ["Two Hand Touch", "Level 2 | Challenging"],
  },
  {
    value: "Full Contact Level 3 | Serious",
    label: ["Full Contact", "Level 3 | Serious"],
  },
  {
    value: "All Pro Elite Level 4 | Ruthless",
    label: ["All Pro Elite", "Level 4 | Ruthless"],
  },
  {
    value: "No Mercy Level 5 | Insane",
    label: ["No Mercy", "Level 5 | Insane"],
  },
];

export const LeagueSteps = [
  { id: 1, key: "add-league-details", label: "Add league details" },
  { id: 2, key: "edit-your-team", label: "Edit your team" },
  { id: 3, key: "edit-rules", label: "Add rules for your league" },
  {
    id: 4,
    key: "invite-other-teams",
    label: "Invite other teams to your league",
  },
  { id: 5, key: "create-a-challenge", label: "Create a challenge" },
  {
    id: 6,
    key: "make-first-post",
    label: "Make your first post",
  },
] as const;
export const SOCIAL_PATTERNS: Record<string, RegExp> = {
  tiktok: /^https?:\/\/(www\.)?tiktok\.com\/@[\w.-]+$/i,
  youtube: /^https?:\/\/(www\.)?youtube\.com\/@[\w.-]+$/i,
  facebook: /^https?:\/\/(www\.)?facebook\.com\/[\w.-]+$/i,
  instagram: /^https?:\/\/(www\.)?instagram\.com\/[\w.-]+$/i,
  x: /^https?:\/\/(www\.)?x\.com\/[\w.-]+$/i,
};
